import { CheckCircle2 } from "lucide-react";

export const USAGE_FILTERS = [
	{
		key: "product_id",
		label: "Producto",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar producto",
		options: [],
		multiple: true,
	},
	{
		key: "estate_parent_id",
		label: "Campo Origen",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar campo",
		options: [],
	},
	{
		key: "business_center_id",
		label: "Centro de Costo",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar centro de costo",
		options: [],
		multiple: true,
	},
	{
		key: "operator_id",
		label: "Operador",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar operador",
		options: [],
	},
	{
		key: "type_oa_id",
		label: "Tipo OA",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar tipo OA",
		options: [],
	},
	{
		key: "oa_code",
		label: "N° OA",
		type: "text",
		value: "",
		visible: true,
		placeholder: "Ingresar N° OA",
	},
	{
		key: "type_movement_id",
		label: "Tipo de Movimiento",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar tipo de movimiento",
		options: [
			{ value: "1", label: "Aplicación" },
			{ value: "2", label: "Traspaso" },
			{ value: "credit_notes", label: "Nota de crédito" },
			{ value: "stolen", label: "Robo" },
		],
	},
	{
		key: "season_id",
		label: "Temporada",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar temporada",
		options: [],
	},
	{ key: "date_from", label: "Fecha Uso Desde", type: "date", value: "", visible: true, placeholder: "Fecha uso desde" },
	{ key: "date_to", label: "Fecha Uso Hasta", type: "date", value: "", visible: true, placeholder: "Fecha uso hasta" },
	{
		key: "sync_failed",
		label: "Integración",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Todos",
		options: [{ value: "true", label: "Sin sincronizar" }],
	},
];

export const USAGE_METADATA = {
	title: "Historial de Usos",
	subtitle: "Visualiza el historial de todos los usos de productos",
	breadcrumb: "Usos",
	icon: CheckCircle2,
	path: "/historiales/usos",
	apiType: "usage",
};

export const USAGE_BASE_TABLE = {
	page: 1,
	per_page: 100,
	order_by: "created_date",
	order_dir: "desc",
};
